import { Vue } from '~/addiesaas'
import BaseUriMixin from '../mixins/base-uri'

Vue.mixin(BaseUriMixin)
